module.exports = __webpack_public_path__ + "koddi_logo.4f296c44.png";